import { useGSAP } from "@gsap/react"
import gsap from "gsap"
import CustomEase from "gsap/CustomEase"
import { Draggable } from "gsap/Draggable"
import { Flip } from "gsap/Flip"
import InertiaPlugin from "gsap/InertiaPlugin"
import { SplitText } from "gsap/SplitText"
import type { FC, PropsWithChildren } from "react"

gsap.registerPlugin(SplitText, CustomEase, InertiaPlugin, Draggable, Flip)

export const WithGsap: FC<PropsWithChildren> = ({ children }) => {
  useGSAP(() => {
    gsap.config({
      nullTargetWarn: false
    })

    gsap.defaults({
      ease: "power2.inOut",
      duration: 1
    })

    gsap.delayedCall(1, () => {
      // ScrollTrigger.refresh()
    })
  }, [])

  return children
}
